<script setup>
import { ref,onMounted } from 'vue'

import { productOfferService } from "@/services/productOfferService";
import CategoriesTable from "./components/CategoriesTable.vue";
import { shopService } from '../services/shopService.js';
import ArgonButton from "@/components/ArgonButton.vue";
import ArgonSwitch from "@/components/ArgonSwitch.vue";


const count = ref(0);
const Categories = ref();
const Buildiers = ref();
const canDoAction = ref(true);
const hasBuilder = ref(true);

import { computed } from "vue";
import { useStore } from "vuex";

const store = useStore();

const shopId = computed(() => store.getters.selectedShopId);

onMounted( async () => {
  count.value = -1;
  await loadData();
})

async function loadData() {
  console.log("hasBuilder",hasBuilder.value)
  productOfferService.getCategories(hasBuilder.value).then(response => {
    console.log('Data loaded :', response.data);
    if(response.data!=null && response.data.Success==true){
      Categories.value = response.data.Data;
      
    }
  })
  .catch(error => {
    console.error('Error logging in:', error);
  }).finally(()=>{canDoAction.value=true;});

  try{
    var result = await shopService.getBuilders();
    if(result.data!=null){
      console.log(result);
      Buildiers.value=result.data.Data;

    }
  }catch(error){
    alert(error);
  }
}

async function onBuilderChanged({ categoryId, builderName }) {
    console.log('onBuilderChanged:',categoryId,builderName);
    try{
      var result = shopService.setBuilderForCategory(shopId.value,categoryId,builderName);
      if(result.data!=null){
        console.log(result.data.Data);    
      }
    }catch(error){
      alert(error);
    }

}


</script>
<template>
  <div class="card m-4">

      <!-- Header -->
      <div class="card-header pb-0">
          <div class="d-flex justify-content-between align-items-center">
              <h6 class="mb-0">
                  Filtry
              </h6>

              <argon-button
                  color="dark"
                  variant="gradient"
                  size="sm"
                  @click="loadData()"
              >
                  <i class="fas fa-search me-2"></i>
                  Filtruj
              </argon-button>
          </div>
      </div>

      <!-- Body -->
      <div class="card-body">

          <div class="row g-3 align-items-end">

              <!-- Kategoria -->
              <div class="col-lg-5">

                  <label class="form-label">
                      Pokaz tylko z Builder 
                  </label>

                  <argon-switch id="xxx" name="xxx" v-model="hasBuilder"></argon-switch>
                  

              </div>
          </div>

      </div>


    </div>
    <div class="py-4 container-fluid">
      <div class="row">
        <div class="col-12">
          <categories-table v-model="Categories" :builders="Buildiers" @builder-changed="onBuilderChanged"/>
        </div>
      </div>
    </div>
</template>
